// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'normalize.css' // 引入样式重置
import Axios from 'axios' // 引入数据请求工具 axios
import interceptors from '@/tools/axios.js' // axios 拦截器
import ElementUI, { Message } from 'element-ui' // 引入 ui 库
import 'element-ui/lib/theme-chalk/index.css' // 引入 ui 库样式表
import VueAMap from 'vue-amap' // 引入高德地图
import store from '@/store' // 引入 vuex 状态管理
import myFilter from '@/filters' // 引入filter
import Icon from 'vue-svg-icon/Icon.vue' // 引入svg
import mixins from '@/mixins'
import App from './App'
import router from './router'


Vue.config.productionTip = false
Vue.use(ElementUI) // 挂载 ui 库
Object.defineProperty(Vue.prototype, '$ajax', { value: Axios }) // 全局注册 this.$ajax -> axios
Vue.mixin(mixins)
Vue.prototype.$toast = (message, type = 'warning') => Message({
  message,
  type,
  center: true
})
Vue.use(VueAMap) // 挂载高德地图
VueAMap.initAMapApiLoader({
  key: '49ae7e4552909cf33faba70443ad775b',
  plugin: [
    // 'AMap.DistrictSearch', // 热力图用，先注释
    // 'AMap.DistrictLayer',
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor',
    'AMap.Riding'
  ],
  // 引入ui组件库
  uiVersion: '1.0.11',
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
})
interceptors() // 初始化拦截器
// 挂载filter到全局filter
for (let key in myFilter) {
  Vue.filter(key, myFilter[key])
}
Vue.component('icon', Icon) // 挂载Icon





/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js